/* eslint-disable sort-vars */
/* eslint-disable one-var-declaration-per-line */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable newline-per-chained-call */
import { Content } from "@iventis/translations/content/typed-content";
import * as Yup from "yup";
import { UseIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { TimeStrings } from "./event.types";
import { TimeType } from "./time-rules.types";
import { isFirstTimeStringBefore, isTimeStringValid } from "./schedule-helper-functions";

export const defaultEventValidations = (translate: UseIventisTranslate, timeStrings?: TimeStrings) => {
    const parentStartTime = timeStrings?.startTime;
    const parentEndTime = timeStrings?.endTime;
    return {
        // Duration has to be an integer
        duration: Yup.number().integer(),
        // Start time has to be a string
        startTime: Yup.string()
            .nullable(false)
            // Time Type is fixed then test the other conditions
            .when("timeType", {
                is: TimeType.Fixed,
                then: Yup.string()
                    .test("isValid", translate(Content.schedule2.validation.startTimeValid), (startTime) => isTimeStringValid(startTime))
                    .test("isWithinParent", translate(Content.schedule2.validation.startTimeWithinParent), (startTime) =>
                        parentEndTime ? isFirstTimeStringBefore(parentStartTime, startTime) : true
                    ),
            }),
        // End time has to be a string
        endTime: Yup.string()
            .nullable(false)
            .when("timeType", {
                // Time Type is fixed then test the other conditions
                is: TimeType.Fixed,
                then: Yup.string()
                    .when("startTime", (startTime, schema: Yup.StringSchema) =>
                        schema.test("isBefore", translate(Content.schedule2.validation.endTimeBeforeStartTime), (endTime) => isFirstTimeStringBefore(startTime, endTime))
                    )
                    .test("isValid", translate(Content.schedule2.validation.endTimeValid), (endTime) => isTimeStringValid(endTime))
                    .test("isWithinParent", translate(Content.schedule2.validation.endTimeWithinParent), (endTime) =>
                        parentEndTime ? isFirstTimeStringBefore(endTime, parentEndTime) : true
                    ),
            }),
    };
};
